import { dbObjectMeta, type CoreApplicationObjectType } from '@iotv/iotv-v3-types'
import { AttributeMode, type UserAttributeDefs } from '../types/ModelTypes'
import { DEBUG_OVERRIDE, NOT_LAMBDA } from '../util/lambda/debug'
import { enumerable } from './constructs/enumerableDecorator'

const debug = DEBUG_OVERRIDE || (NOT_LAMBDA && false)

class ModelCommon implements CoreApplicationObjectType {
  constructor(className: string, object: any) {
    if (className && object) {
      // debug && console.log("Object given to ModelCommon:", object);
      Object.assign(this, object)

      // debug && console.log("Object constructed by ModelCommon:", this);
      this.type = className
      if (object.id) {
        this.id = object.id
        if (object.pk === undefined) {
          this.pk = this.type + ':' + this.id
        } else {
          this.pk = object.pk
        }

        if (object.sk === undefined) {
          this.sk = this.type + ':' + this.id
        } else {
          this.sk = object.sk
        }
      } else {
        this.pk = object.pk
        this.sk = object.sk
        this.id = object.id
      }
      //const edgeAttibuteDefinition =  typeof getAllEdgeDefinitionTypes === 'function' ? getAllEdgeDefinitionTypes('Customer') : {};
      const attributeDefs = {
        ...this.getUserAttributes() /*...edgeAttibuteDefinition */,
      }

      Object.entries(this).forEach(([k, v]) => {
        if (v === null) {
          if (attributeDefs[k]) {
            const attributeDef = attributeDefs[k]
            if (attributeDef?.default) {
              this[k] = attributeDef.default
            }
          }
          this[k] = undefined
        }
      })
      // debug && console.log( 'this in Model Common after doing something with existing keys', this );
      //debug && console.log(`On construction ${className} has userAtts`, Object.keys(attributeDefs))

      Object.entries(attributeDefs).forEach(([attKey, attDef]) => {
        if (this[attKey] === undefined && attDef?.default !== undefined) {
          debug && console.log({ attKey, attDef, current: this.key })
          this[attKey] = attDef.default
        }
      })

      // debug && console.log('this in Model Common after set default', this);
    } else {
      this.type = 'Unknown'
      this.pk = 'Unknown'
      this.sk = 'Unknown'
      this.id = 'Unkowwn'
    }
  }

  [someProperty: string]: any

  type: string

  pk: string

  sk: string

  id: string

  description: string | undefined

  metadata?: dbObjectMeta
  clone() {
    // const zombie = new (this.constructor())
    // return Object.assign(zombie, this);
    //return Object.assign(new (<any>this.constructor()), this);
  }

  @enumerable(false)
  setAdditionalUserAttributeDefs(additionalUserAttributeDefs: UserAttributeDefs) {
    this._additionalUserAttributeDefs = additionalUserAttributeDefs
  }

  @enumerable(false)
  getAdditionalUserAttributeDefs() {
    return this._additionalUserAttributeDefs
  }

  @enumerable(false) _additionalUserAttributeDefs: UserAttributeDefs = {}

  @enumerable(false) getUserAttributes(): UserAttributeDefs {
    return {
      name: {
        type: 'String',
        editable: true,
        required: true,
      },
      description: {
        type: 'String',
        editable: true,
        validation: {
          //may be empty to allow global whitelist check
        },
      },
      type: {
        type: 'String',
        editable: false,
        mode: AttributeMode.readOnly, //may have mode
      },
      ...this._additionalUserAttributeDefs,
    }
  }

  getLinkAttributes(): UserAttributeDefs {
    return {
      name: {
        type: 'String',
      },
      description: {
        type: 'String',
        validation: {
          //may be empty to allow global whitelist check
        },
      },
      type: {
        type: 'String',
        mode: AttributeMode.readOnly, //may have mode
      },
    }
  }

  isSaveable() {
    return true
  }

  globallyValid(text: string) {
    const allow = new RegExp('[^$]', 'i')

    const disallow = new RegExp('xxxxxxxyyyyyzzz', 'i')
    /*
        console.log(`disallow: ${disallow}`)
        console.log(`test: ${text}`)
        console.log(`global allow ${allow.test(text)}`)
        console.log(`global disallow ${disallow.test(text)}`)
        */
    return allow.test(text) && !disallow.test(text)
  }

  validate() {
    const validationKeys: UserAttributeDefs = this.getUserAttributes()
    //console.log('This', this)
    const errors: { [k: string]: {} | undefined } = {}

    Object.entries(validationKeys).map(([k, v]) => {
      const testValue = this[k]
      if (v?.validation && typeof testValue === 'string') {
        //console.log(`checking ${k}`)
        if (this.globallyValid(testValue) === false) errors[k] = `Please remove special characters or certain words from this field (${k} on ${this.name})`

        if (v.validation.regex && v.validation.regex instanceof RegExp && errors[k] === undefined) {
          //console.log('DOING BLACKLIST')
          const test = v.validation.regex.test(testValue)
          // console.log(`blacklist outcome ${test}`)
          // console.log(`pass is  ${v.validation.pass}`)
          if ((test && !v.validation.pass) || (!test && v.validation.pass)) errors[k] = v.validation.invalidMessage
        } else if (typeof v.validation.regex === 'string') {
          //TODO deal with string from config
        }
      }
    })
    return Object.keys(errors).length > 0 ? errors : null
  }
}

export { ModelCommon }
